export default function JohnsonCityFinalCTA() {
  return (
    <section id="contact" className="bg-[#1A365D] py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20panoramic%20view%20of%20the%20Tri-Cities%20region%20Northeast%20Tennessee%20Appalachian%20highlands%20rolling%20green%20mountain%20ridges%20and%20river%20valleys%20at%20dusk%20with%20warm%20amber%20sky%2C%20wide%20landscape%20photograph%20showing%20the%20blue%20ridge%20mountains%20surrounding%20Johnson%20City%20and%20Washington%20County%20Tennessee&width=1600&height=700&seq=jc-cta-bg-2026&orientation=landscape"
          alt="Johnson City Tennessee Mountains"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#F6C344]/20 text-[#F6C344] text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full mb-6">
          <i className="ri-map-pin-2-line"></i>
          Johnson City, TN — Tri-Cities Passport Specialists
        </div>

        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
          Don&apos;t Drive to Knoxville.
          <br />
          <span className="text-[#F6C344]">Get Your Passport Here.</span>
        </h2>

        <p className="text-white/70 text-lg leading-relaxed max-w-2xl mx-auto mb-10">
          Whether you&apos;re an ETSU student heading to a semester abroad, a Mountain States physician traveling to an international conference, or a Washington County family planning a European vacation — we get your passport done fast, without the 100-mile Knoxville drive.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center justify-center gap-2 bg-[#F6C344] text-[#1A365D] font-bold text-lg px-10 py-4 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap"
          >
            <i className="ri-passport-line"></i>
            Start My Application Now
          </a>
          <a
            href="tel:+18888881234"
            className="inline-flex items-center justify-center gap-2 bg-white/10 text-white font-semibold text-lg px-10 py-4 rounded-lg hover:bg-white/20 transition-all border border-white/20 whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Call for Emergency Help
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-12">
          <div className="bg-white/10 rounded-xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/20 mx-auto mb-3">
              <i className="ri-flashlight-line text-[#F6C344] text-xl"></i>
            </div>
            <h4 className="font-bold text-white text-lg mb-1">24 Hours</h4>
            <p className="text-white/60 text-xs">Emergency passport for same-week departures</p>
          </div>
          <div className="bg-white/10 rounded-xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/20 mx-auto mb-3">
              <i className="ri-graduation-cap-line text-[#F6C344] text-xl"></i>
            </div>
            <h4 className="font-bold text-white text-lg mb-1">ETSU Ready</h4>
            <p className="text-white/60 text-xs">Specialized study abroad processing for East Tennessee State</p>
          </div>
          <div className="bg-white/10 rounded-xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/20 mx-auto mb-3">
              <i className="ri-route-line text-[#F6C344] text-xl"></i>
            </div>
            <h4 className="font-bold text-white text-lg mb-1">Zero Drive</h4>
            <p className="text-white/60 text-xs">100-mile Knoxville trip completely eliminated</p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-white/50 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>No Appointment Required</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>Pre-Submission Document Review</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>Overnight Delivery to Johnson City</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>Emergency 24/7 Support Line</span>
          </div>
        </div>
      </div>
    </section>
  );
}